import { applyMiddleware, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
import { createHashHistory } from 'history';
import { createLogger } from 'redux-logger';
import createSagaMiddleware from 'redux-saga';
import { routerMiddleware, push } from 'react-router-redux';
import reducers from './reducers';
import sagas from './sagas';

export const history = createHashHistory();
const actionCreators = {
  push,
};

const logger = createLogger({
  level: 'info',
  collapsed: true,
});

const router = routerMiddleware(history);

// If Redux DevTools Extension is installed use it, otherwise use Redux compose
/* eslint-disable no-underscore-dangle */
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
  ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
      // Options: http://extension.remotedev.io/docs/API/Arguments.html
      actionCreators,
    })
  : compose;

const sagaMiddleware = createSagaMiddleware();

let middleware =
  process.env.NODE_ENV !== 'production'
    ? composeEnhancers(applyMiddleware(sagaMiddleware, thunk, logger, router))
    : composeEnhancers(applyMiddleware(sagaMiddleware, thunk, router));

if (process.env.NODE_ENV !== 'production') {
  // configure redux-devtools-extension
  // @see https://github.com/zalmoxisus/redux-devtools-extension
  const devToolsExtension = window.devToolsExtension; // eslint-disable-line prefer-destructuring
  if (typeof devToolsExtension === 'function') {
    middleware = compose(middleware, devToolsExtension());
  }
}

export const configureStore = initialState => {
  const store = createStore(reducers, initialState, middleware);
  sagaMiddleware.run(sagas);

  if (module.hot) {
    module.hot.accept('./reducers', () =>
      store.replaceReducer(require('./reducers').default),
    );
  }
  return store;
};



// WEBPACK FOOTER //
// ./src/core/store.js